export default __webpack_public_path__ + "media/images/previous-26161d6444c92b2902d6cddf2dbd952e.png";